interface SubscriptionPlan {
  id: string;
  name: string;
  description: string;
  price: number;
  period: string; // This should be properly defined for each plan
  features: string[];
  isPopular?: boolean;
}

export const subscriptionPlans: SubscriptionPlan[] = [
  {
    id: 'basic',
    name: 'Basic',
    description: 'Essential legal news updates',
    price: 150,
    period: '6 month',
    features: [
      'Ad free Content',
      'Daily legal news updates',
      'Unlimited access for everything',
      'Exclusive notifications on phone and via email. Weekly judgement text/video roundups',
      'Case summaries',
      'Free copies of judgments with download facility'
    ]
  },
  {
    id: 'professional',
    name: 'Professional',
    description: 'For legal practitioners',
    price: 500,
    period: '1 year',
    features: [
      'Ad free Content',
      'Daily legal news updates',
      'Unlimited access for everything',
      'Exclusive notifications on phone and via email. Weekly judgement text/video roundups',
      'Case summaries',
      'Free copies of judgments with download facility'
    ],
    isPopular: true
  },
  {
    id: 'business',
    name: 'Business',
    description: 'For law firms and teams',
    price: 999,
    period: '2 years',
    features: [
      'Ad free Content',
      'Daily legal news updates',
      'Unlimited access for everything',
      'Exclusive notifications on phone and via email. Weekly judgement text/video roundups',
      'Case summaries',
      'Free copies of judgments with download facility'
    ]
  },
  {
    id: 'enterprise',
    name: 'Enterprise',
    description: 'Custom solutions for large organizations',
    price: 1500,
    period: '3 years',
    features: [
      'Ad free Content',
      'Daily legal news updates',
      'Unlimited access for everything',
      'Exclusive notifications on phone and via email. Weekly judgement text/video roundups',
      'Case summaries',
      'Free copies of judgments with download facility'
    ]
  }
];